// custom typefaces
import 'typeface-rubik';

// custom CSS styles
import './src/style.css';
import './src/App.css';

// Highlighting for code blocks
import 'prismjs/themes/prism.css';
